module.exports = __webpack_public_path__ + "static/media/pic-1.fa8dcbfd.jpg";